import { MiembroFamilia, PersonaLugar } from '../../../servicios/lugares.service';
import { ToastService } from '../../../servicios/toast.service';
import { LugaresService, Lugar } from 'src/app/servicios/lugares.service';
import { HeaderInfoService } from '../../../servicios/header-info.service';
import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-detalle-apartamento',
  templateUrl: './detalle-apartamento.component.html',
  styleUrls: ['./detalle-apartamento.component.scss']
})
export class DetalleApartamentoComponent implements OnInit {

  opciones: Array<string> = environment.production ? ["Titulares"] : ["Titulares", "Grupo familiar", "Agregar titular"];
  // opciones: Array<string> = environment.production ? ["Titular"] : ["Titular", "Grupo familiar", "Inmueble"];
  actual: string = this.opciones[0];
  titularAsignado: boolean = false;
  grupoFamiliar: MiembroFamilia[];
  titulares: MiembroFamilia[];
  idInmueble: string;
  usuarioIdTitular: number;
  cargando: boolean = false;

  public tiposDeDocumentos = [
    "Cédula de ciudadanía",
    "NIT",
    "Cédula Extranjería",
    "Tarjeta Identidad",
    "Pasaporte",
    "Registro Civil",
  ];

  public titularForm: UntypedFormGroup = new UntypedFormGroup({
    nombres: new UntypedFormControl(null, [Validators.required]),
    apellidos: new UntypedFormControl(null, [Validators.required]),
    correo: new UntypedFormControl(null, [Validators.required, Validators.email]),
    nombreTitular: new UntypedFormControl(null),
    tipoDocumento: new UntypedFormControl(null),
    documento: new UntypedFormControl(null),
    indicativo: new UntypedFormControl("+57", [Validators.required]),
    celular: new UntypedFormControl(null, [Validators.required]),
    estado: new UntypedFormControl(null),
  });

  public inmuebleForm: UntypedFormGroup;

  public inmuebleFormInitialValues;

  constructor(private headerInfoService: HeaderInfoService, private lugaresService: LugaresService, private toastService: ToastService, private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.titularForm.get("nombreTitular").value
    this.headerInfoService.cambiarTituloTarjeta("EDITAR INFORMACIÓN DE LOS OCUPANTES");
    this.headerInfoService.cambiarTextoTarjeta("Selecciona la opción que deseas editar, llena y/o edita la  información correspondiente a unidad.");
    // this.headerInfoService.cambiarImagenTarjeta('./../../../../assets/header/editar-apartamento.svg');

    this.idInmueble = this.route.snapshot.paramMap.get("id");

    this.lugaresService.getTitularesResidentes(this.idInmueble).subscribe(res => {
      const { titular, titulares, residentes } = res.data;

      this.titularAsignado = !!titular;

      // Group familiar mapping from Residentes
      this.grupoFamiliar = residentes.map(r => ({
        id: r.id,
        name: r.nombres,
        last_name: r.apellidos,
        email: r.correo,
        phone: r.celular,
        indicative: r.indicativo,
        type_document: r.tipoDocumento,
        number_document: r.numeroDocumento,
        status: 1, // Assuming active
        guests_allowed: r.autorizaVisita,
        imagen: r.imagen
      }));

      this.titulares = titulares.map(r => ({
        id: r.id,
        name: r.nombres,
        last_name: r.apellidos,
        email: r.correo,
        phone: r.celular,
        indicative: r.indicativo,
        type_document: r.tipoDocumento,
        number_document: r.numeroDocumento,
        status: 1, // Assuming active
        guests_allowed: r.autorizaVisita,
        estadoAsignacion: r.estadoAsignacion,
        imagen: r.imagen
      }));
      
    }, err => {
      this.toastService.mostrarToast(err.error?.message || "Error al consultar la información");
    });
  }

  handleOpcion(opcion: string): void {
    this.actual = opcion;
  }

  get nombreTitular(): string {
    return this.titularForm.get("nombreTitular").value;
  }

  get tipoDocumento(): string {
    return this.titularForm.get("tipoDocumento").value;
  }

  get documento(): string {
    return this.titularForm.get("documento").value;
  }

  get indicativo(): string {
    return this.titularForm.get("indicativo").value;
  }

  get celular(): string {
    return this.titularForm.get("celular").value;
  }

  get nombres(): string {
    return this.titularForm.get("nombres").value;
  }

  get apellidos(): string {
    return this.titularForm.get("apellidos").value;
  }

  get correo(): string {
    return this.titularForm.get("correo").value;
  }

  get area(): string {
    return this.inmuebleForm.get("area").value;
  }

  get apartamento(): string {
    return this.inmuebleForm.get("apartamento").value;
  }

  get costoAdministracion(): number {
    return this.inmuebleForm.get("costoAdministracion").value;
  }

  get estado(): number {
    return this.inmuebleForm.get("estado").value;
  }

  public eliminarTitular(miembro?: MiembroFamilia): void {
    const usuarioId = miembro ? miembro.id : this.usuarioIdTitular;
    if (!usuarioId) {
      this.toastService.mostrarToast("No se encontró el ID del usuario titular para retirar");
      return;
    }

    this.cargando = true;
    this.lugaresService.eliminarTitularInmueble(this.idInmueble, usuarioId).subscribe(res => {
      this.cargando = false;
      this.toastService.mostrarToast(res.message || res.data?.mensaje || "Titular eliminado correctamente");
      this.titularAsignado = false;
      this.usuarioIdTitular = null;
      this.titularForm = new UntypedFormGroup({
        nombres: new UntypedFormControl(null),
        apellidos: new UntypedFormControl(null),
        correo: new UntypedFormControl(null),
        nombreTitular: new UntypedFormControl(null),
        tipoDocumento: new UntypedFormControl(null),
        documento: new UntypedFormControl(null),
        indicativo: new UntypedFormControl("+57"),
        celular: new UntypedFormControl(null),
        estado: new UntypedFormControl(null),
      });
      this.ngOnInit();
    }, (err) => {
      this.cargando = false;
      this.toastService.mostrarToast(err.error?.data?.message || err.error?.message || "Error al retirar titular");
    });
  }

  public agregarTitular(): void {
    if (this.titularForm.valid) {
      this.cargando = true;
      this.lugaresService.asignarTitularInmueble(this.idInmueble, this.correo, this.nombres, this.apellidos, this.indicativo, this.celular, this.tipoDocumento, this.documento).subscribe(res => {
        this.cargando = false;
        this.toastService.mostrarToast(res.message);
        this.ngOnInit();
        this.titularForm.reset();
        this.actual = this.opciones[0];
      }, (err) => {
        this.cargando = false;
        this.toastService.mostrarToast(err.error.message);
      });
    } else {
      this.titularForm.markAllAsTouched();
      this.toastService.mostrarToast("Por favor complete todos los campos");
    }
  }

  public actualizarInformacionInmueble() {
    if (this.inmuebleForm.valid) {
      this.lugaresService.actualizarInformacionInmueble(this.idInmueble, this.area, this.apartamento, this.costoAdministracion, this.estado).subscribe(res => {
        this.toastService.mostrarToast("Datos actualizados");

        this.inmuebleForm = new UntypedFormGroup({
          area: new UntypedFormControl(this.area, [Validators.required]),
          apartamento: new UntypedFormControl(this.apartamento, [Validators.required]),
          costoAdministracion: new UntypedFormControl(this.costoAdministracion, [Validators.required]),
          estado: new UntypedFormControl(this.estado)
        });

        this.inmuebleFormInitialValues = this.inmuebleForm.value;
      }, (err) => {
        this.toastService.mostrarToast(err.error.data.message);
      });
    } else {
      this.toastService.mostrarToast("Por favor complete todos los campos");
    }
  }

  public numSequence(n: number): Array<number> {
    return Array(n);
  }

  public cambiarInvitadosPermitidos(miembro: MiembroFamilia) {
    this.lugaresService.cambiarInvitadosPermitidosMiembroFamilia(this.idInmueble, miembro).subscribe(res => {
      this.toastService.mostrarToast("Permiso de invitados actualizado");

      this.grupoFamiliar = this.grupoFamiliar.map(miembroFamilia => {
        if (miembroFamilia.id === miembro.id) {
          return {
            ...miembroFamilia,
            guests_allowed: parseInt(res.data.lugar.guests_allowed)
          }
        } else {
          return miembroFamilia;
        }
      })

    }, (err) => {
      this.toastService.mostrarToast(err.error.data.message);
    });
  }

  public cambiarEstado(estado: number) {
    this.inmuebleForm.get("estado").setValue(estado);
  }
}
